import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import recourses from './resources';

i18n.use(initReactI18next).init({
  lng: 'fa',
  fallbackLng: 'fa',
  interpolation: {
    escapeValue: false
  },
  resources: recourses
});

export default i18n;
